// extracted by mini-css-extract-plugin
export default {"title":"temple-list-module__title--zSJuT","metadata":"temple-list-module__metadata--yQYLt"};